module.exports = __webpack_public_path__ + "img/Driver.ed167fec.jpg";